<mat-dialog-content>
  @for (item of details; track item) {
    <mat-accordion class="example-headers-align" multi>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          @if (item.electronic_number === 'PENDING') {
            <mat-panel-title>
              {{ 'Invoice' | translate }} {{ item.invoice_number }}
            </mat-panel-title>
          }
          @if (item.electronic_number !== 'PENDING') {
            <mat-panel-title>
              {{ 'Invoice' | translate }} {{ item.electronic_number }}
            </mat-panel-title>
          }
          <mat-panel-description>
            {{ 'Click for details' | translate }}
            <mat-icon>monetization_on</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <p>
          {{ 'Created Date:' | translate }}
          {{ item.createdDate | date: 'short' }}
        </p>
        <p>{{ 'Due Date:' | translate }} {{ item.dueDate | date: 'short' }}</p>
        <p>{{ 'Days past due:' | translate }} {{ item.daysBetweenDates }}</p>
        <p>
          {{ 'Total Invoice:' | translate }} {{ item.total | currency: 'USD' }}
        </p>
        <p>
          {{ 'Pending:' | translate }} {{ item.totalPaid! | currency: 'USD' }}
        </p>
        <p>
          {{ 'Completed:' | translate }}
          {{ item.total - item.totalPaid! | currency: 'USD' }}
        </p>
        @if (item.creditNote) {
          @if (item.creditNote!.length > 0) {
            <p>{{ 'Credit Notes' | translate }}:</p>
            <table
              mat-table
              [dataSource]="item.creditNote!"
              class="mat-elevation-z8"
            >
              <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'Code' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">{{ element.code }}</td>
              </ng-container>
              <ng-container matColumnDef="total">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'Total' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">{{ element.total }}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="columnsNotes"></tr>
              <tr mat-row *matRowDef="let row; columns: columnsNotes"></tr>
            </table>
          }
        }
        @if (item.debitNote) {
          @if (item.debitNote!.length > 0) {
            <p>{{ 'Debit Notes' | translate }}:</p>
            <table
              mat-table
              [dataSource]="item.debitNote!"
              class="mat-elevation-z8"
            >
              <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'Code' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">{{ element.code }}</td>
              </ng-container>
              <ng-container matColumnDef="total">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'Total' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">{{ element.total }}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="columnsNotes"></tr>
              <tr mat-row *matRowDef="let row; columns: columnsNotes"></tr>
            </table>
          }
        }
        @if (item.paid) {
          @if (item.paid!.length > 0) {
            <p>{{ 'Payments' | translate }}:</p>
            <table mat-table [dataSource]="item.paid!" class="mat-elevation-z8">
              <ng-container matColumnDef="identifier" sticky>
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'ID' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.identifier }}
                </td>
              </ng-container>
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'Type' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.type | translate }}
                </td>
              </ng-container>
              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'Date' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.date | date: 'shortDate' }}
                </td>
              </ng-container>
              <ng-container matColumnDef="value">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'Value' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">{{ element.value }}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="columnsPays"></tr>
              <tr mat-row *matRowDef="let row; columns: columnsPays"></tr>
            </table>
          }
        }
        @if (item.purchasePaid) {
          @if (item.purchasePaid!.length > 0) {
            <p>{{ 'Payments' | translate }}:</p>
            <table
              mat-table
              [dataSource]="item.purchasePaid!"
              class="mat-elevation-z8"
            >
              <ng-container matColumnDef="identifier" sticky>
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'ID' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.identifier }}
                </td>
              </ng-container>
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'Type' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.type | translate }}
                </td>
              </ng-container>
              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'Date' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.date | date: 'shortDate' }}
                </td>
              </ng-container>
              <ng-container matColumnDef="value">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'Value' | translate }}
                </th>
                <td mat-cell *matCellDef="let element">{{ element.value }}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="columnsPays"></tr>
              <tr mat-row *matRowDef="let row; columns: columnsPays"></tr>
            </table>
          }
        }
        @if (item.creditNote) {
          @if (item.creditNote!.length <= 0) {
            <div class="alert alert-danger">
              {{ 'NO CREDIT NOTES' | translate }}
            </div>
          }
        }
        @if (item.debitNote) {
          @if (item.debitNote!.length <= 0) {
            <div class="alert alert-danger">
              {{ 'NO DEBIT NOTES' | translate }}
            </div>
          }
        }
        @if (item.paid) {
          @if (item.paid!.length <= 0) {
            <div class="alert alert-danger">
              {{ 'NO PAYMENTS' | translate }}
            </div>
          }
        }
        @if (item.purchasePaid) {
          @if (item.purchasePaid!.length <= 0) {
            <div class="alert alert-danger">
              {{ 'NO PAYMENTS' | translate }}
            </div>
          }
        }
      </mat-expansion-panel>
    </mat-accordion>
  }
</mat-dialog-content>
